import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import CondensedPersonnel from 'src/models/personnel/CondensedPersonnel';

interface IExistingLmMatchDialogProps {
    dialogName: string;
    matches: Array<CondensedPersonnel>;
    getRoleName: (code: string) => string;
    onUseExisting: (tsdNo: number) => void;
    onCreateNew: () => void;
    onCancel: () => void;
}

// Shown by AddPersonnelDialog when the name just entered already matches one or more existing LM
// rows (see AddPersonnelDialog's own onCreate comment) - "Add Personnel" previously always created
// a brand new LM_NO/TSD_NO regardless, so re-adding someone already in LM (e.g. added directly to
// LM by another process, not through this dialog) silently produced a duplicate, disconnected
// record. This lets the user attach the new LMS login to the existing TSD_NO instead.
const ExistingLmMatchDialog = (props: IExistingLmMatchDialogProps) => {
    return (
        <Dialog title="Possible Existing Match" dialogName={props.dialogName} bodyStyle={{ width: '55%' }} isExitButtonInvisible={true}>
            <p>
                {props.matches.length === 1
                    ? 'A record already exists in LM with this name:'
                    : 'Records already exist in LM with this name:'}
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        <th className="table-header" style={{ width: '12%' }}>Number</th>
                        <th className="table-header" style={{ width: '18%' }}>Role</th>
                        <th className="table-header" style={{ width: '25%' }}>Name</th>
                        <th className="table-header" style={{ width: '25%' }}>Corp. Name</th>
                        <th className="table-header" style={{ width: '20%' }} />
                    </tr>
                </thead>
                <tbody>
                    {props.matches.map((match) => (
                        <tr key={match.tsdNo}>
                            <td>{match.tsdNo}</td>
                            <td>{props.getRoleName(match.role)}</td>
                            <td>{match.lastName}, {match.firstName}</td>
                            <td>{match.corporationName}</td>
                            <td>
                                <Button
                                    text="Use This"
                                    className="blue-hover-button"
                                    style={{ width: '100%', height: '2.5rem' }}
                                    onClick={() => props.onUseExisting(match.tsdNo)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p style={{ marginTop: '1rem' }}>
                Use one of the existing records above, or create a new, separate record for this name.
            </p>
            <div className="button-row" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '16rem' }}
                    text="Create New Anyway"
                    onClick={() => props.onCreateNew()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '10rem' }}
                    text="Cancel"
                    onClick={() => props.onCancel()}
                />
            </div>
        </Dialog>
    );
};

export default ExistingLmMatchDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/ExistingLmMatchDialog.tsx